import { render, staticRenderFns } from "./new-group-message-screen.vue?vue&type=template&id=f4cdd5b0&"
import script from "./new-group-message-screen.vue?vue&type=script&lang=js&"
export * from "./new-group-message-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports